import { MantineThemeOverride } from "@mantine/core";

type TThemeSizes = Pick<MantineThemeOverride, "spacing" | "radius">;

export const mantineThemeSizes: TThemeSizes = {
  spacing: {
    sm: "8px",
    md: "12px",
    lg: "24px",
  },
  radius: {
    sm: "10px",
    md: "12px",
    lg: "19px",
  },
};
